import PlacesAutocomplete from './PlacesAutocomplete'
import { geocodeByAddress, geocodeByPlaceId, getLatLng } from './utils'

export { geocodeByAddress, geocodeByPlaceId, getLatLng }

export default PlacesAutocomplete
